import { Controller } from "@hotwired/stimulus"

// Scroll-triggered animations using Intersection Observer
// Usage: data-controller="animate" data-animate-class-value="fade-in-up"
//        data-animate-delay-value="0.2" data-animate-threshold-value="0.2"

export default class extends Controller {
  static values = {
    class: { type: String, default: "fade-in-up" },
    delay: { type: Number, default: 0 },
    threshold: { type: Number, default: 0.1 },
    stagger: { type: Number, default: 0.15 }
  }

  static targets = ["item"]

  connect() {
    // Small delay to ensure DOM is ready
    requestAnimationFrame(() => this.setup())
  }

  setup() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      { threshold: this.thresholdValue, rootMargin: "0px 0px -50px 0px" }
    )

    // Only observe item targets, not the container
    if (this.hasItemTarget) {
      this.itemTargets.forEach((item, index) => {
        item.classList.add("animate-hidden")
        item.dataset.animateIndex = index
        this.observer.observe(item)
      })
    } else {
      // If no item targets, animate the controller element itself
      this.element.classList.add("animate-hidden")
      this.element.dataset.animateIndex = 0
      this.observer.observe(this.element)
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target
        const index = parseInt(el.dataset.animateIndex || 0)
        const delay = this.delayValue + (index * this.staggerValue)

        setTimeout(() => {
          el.classList.remove("animate-hidden")
          el.classList.add(`animate-${this.classValue}`)
        }, delay * 1000)

        this.observer.unobserve(el)
      }
    })
  }
}
